import { render, staticRenderFns } from "./PoliciesTimeoffSettingHRM.vue?vue&type=template&id=ea859a00&"
import script from "./PoliciesTimeoffSettingHRM.vue?vue&type=script&lang=js&"
export * from "./PoliciesTimeoffSettingHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports